type VerdantMarkProps = {
  size?: number;
};

export const VerdantMark = ({ size = 32 }: VerdantMarkProps) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="9" fill="var(--verdant-mark-background)" />
    <rect
      x="0.75"
      y="0.75"
      width="30.5"
      height="30.5"
      rx="8.25"
      stroke="var(--verdant-mark-accent)"
      strokeOpacity="0.28"
      strokeWidth="1.5"
    />
    <path
      d="M8.5 10H23.5M16 10V22.5"
      stroke="var(--verdant-mark-accent)"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <circle cx="8.5" cy="10" r="2" fill="var(--verdant-mark-node)" />
    <circle cx="23.5" cy="10" r="2" fill="var(--verdant-mark-node)" />
    <circle cx="16" cy="22.5" r="2" fill="var(--verdant-mark-node)" />
  </svg>
);
